import React from 'react'

export default function ModalBody({ children }) {
    return (
        <div className='w-full p-3'>
            {children}
        </div>
    )
}
